module.exports = __webpack_public_path__ + "img/sala_estar.28be42db.jpg";